import { Injectable } from '@angular/core';
import { Router, UrlTree, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from "@app/core/authentication/authentication.service";
import { ConstantService } from '../../shared/services/constant.service';

@Injectable()
export class AuthGuard  {
    constructor(
        private _authService: AuthenticationService,
        private _constService: ConstantService,
        private _router: Router
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | UrlTree {
        const admin = localStorage.getItem("isTypeAdmin");
        if (this._authService.isAuthenticated && admin === "true") {
            // productionadmin stays limited to Issues/Settings; supportadmin has full access.
            if (this._constService._isHardware) {
                return this.deny(state.url);
            }
            return true;
        } else {
            return this.deny(state.url);
        }
    }

    // Preserve the access decision while giving denied navigation a recoverable destination.
    private deny(url: string): UrlTree {
        const reason = !this._authService.isAuthenticated ? 'session'
            : !this._constService.permissionType ? 'profile' : 'permission';
        return this._router.createUrlTree(['/access-recovery'], {
            queryParams: { reason, returnUrl: url }
        });
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | UrlTree {
        return this.canActivate(childRoute, state);
    }
}
